import { render, staticRenderFns } from "./No29.vue?vue&type=template&id=981644c8&scoped=true"
import script from "./No29.vue?vue&type=script&lang=js"
export * from "./No29.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981644c8",
  null
  
)

export default component.exports